<template>
  <Stack class="welcome-view">
    <Stack gap="2">
      <Title>Welcome</Title>
      <p>
        The Client Portal is a secure, client-facing workspace that lets you collect
        information and documents directly from your clients,
        without back-and-forth emails or manual data entry.
      </p>
    </Stack>

    <Stack gap="3">
      <router-link
        v-for="link in links"
        :key="link.name"
        class="welcome-link"
        :to="{ name: link.name }"
      >
        <Icon
          v-if="link.type"
          class="welcome-type"
          :icon="link.type"
        />
        <Stack gap="1">
          <Title size="5">
            {{ link.label }}
          </Title>
          <Subtitle>{{ link.description }}</Subtitle>
        </Stack>
      </router-link>
    </Stack>
  </Stack>
</template>

<script setup>
import { computed } from 'vue';
import { Icon, Subtitle, Title, Stack } from '@stakeui';

const links = computed(() => [
  {
    name: 'advisor-client-portal-setup-dossier',
    label: 'Dossier',
    description: 'Capture Dossier information directly from the Client',
    type: 'fas fa-id-card',
  },
  {
    name: 'advisor-client-portal-setup-checklist',
    label: 'Documents',
    description: 'Request documents directly from the Client',
    type: 'fas fa-folder-open',
  },
  {
    name: 'advisor-client-portal-setup-questionnaires',
    label: 'Questionnaires',
    description: 'Display questionnaire links to the Client',
    type: 'fas fa-question',
  },
]);
</script>

<style scoped>
.welcome-view {
  max-width: 45em;
}

.welcome-link {
  background-color: #fff;
  box-shadow: var(--box-inner-shadow);
  border-radius: 0.75em;
  padding: 1.5em 1.5em 2em;
  display: flex;
  gap: 1em;
}
</style>
